import axios from "axios";
import React from "react";

export const getDesc = (nomenclature_list, code, simple = false) => {

  if (code === "#####")
    return (
      <React.Fragment>
        <tspan x="0" y="0">
          Please contact the factory at&nbsp;
        </tspan>
        <a href="tel:+18003211881">
          <tspan className="fa" x="0" y="20">
            &#xf095;
          </tspan>
          <tspan x="15" y="20">
          <span> (800)-321-1881</span>
          </tspan>
        </a>
        <tspan x="0" y="40">
          for your proper option kit selection.
        </tspan>
      </React.Fragment>
    );

  var return_text = "Un-Known";

  nomenclature_list.forEach(element => {


    if (element.key === code) {
      return_text = element.value;
    }
  });
  //if (return_text === "Un-Known") //alert("Error");
  if (return_text === "A") return "Revision A";
  if (return_text === "OEM" && simple == false)
    return (
      <React.Fragment>
        <tspan x="0" y="0">
          ⍦ ⇒ B - Bohn
        </tspan>
        <tspan x="0" y="20">
          ⍦ ⇒ L - Larkin
        </tspan>
        <tspan x="0" y="40">
          ⍦ ⇒ C - Climate Control
        </tspan>
        <tspan x="0" y="60">
          ⍦ ⇒ H - Chandler
        </tspan>
      </React.Fragment>
    );
  else if (return_text === "OEM" && simple == true) {
    return "⍦ ⇒ B - Bohn, ⍦ ⇒ L - Larkin, ⍦ ⇒ C - Climate Control, ⍦ ⇒ H - Chandler";
  }

  return return_text;
};

export const nomenclature = nomenclature_data => {
  return (dispatch, getState) => {
    axios
      .get("./nomenclature.js")
      .then(function(response) {

        var r = response.data;
        dispatch({ type: "LOAD_NOMENCLATURE", nomenclature_data: r });
      })
      .catch(function(error) {
        dispatch({ type: "LOAD_NOMENCLATURE_ERROR", error });
      });
  };
};
